import _ from "lodash";
import React from "react";
import { Link } from "react-router-dom";
import getEnvEndpoints from "../../utils/endpoints";

const endpoints = getEnvEndpoints();

const ShortFeedItem = ({ post }) => {
  const previewImage = encodeURI(post.imagepreview);
  const previewImageFile = previewImage.startsWith("http")
    ? previewImage
    : `${endpoints.baseContentUrl}${previewImage}`;

  const isPmbok = () => {
    const postMediaType = post?.mediatype && post?.mediatype.length === 1 ? post?.mediatype[0].id : ''
    if (postMediaType === 'MTPmbok6') {
      return "/images/pmbok6-icon.svg";
    }
    if (postMediaType === 'MTPmbok7') {
      return "/images/pmbok7-icon.svg";
    }
    if (postMediaType === 'MTEVM') {
      return "/images/pmbok-mtevm-icon.svg";
    }
    if (postMediaType === 'MTPMO') {
      return "/images/pmopg-icon.svg";
    }
    if (postMediaType === 'MTAPG') {
      return "/images/apg-icon.svg";
    }
    if (postMediaType === 'MTGBA') {
      return "/images/gba-icon.svg";
    }
    if (postMediaType === 'MTWBS') {
      return "/images/wbs-icon.svg";
    }
    if (postMediaType === 'MTSRM') {
      return "/images/srm-icon.svg";
    }
    if (postMediaType === 'MTSPE') {
      return "/images/mtse-icon.svg";
    }
    if (postMediaType === 'MTPGP') {
      return "/images/pgp-icon.svg";
    }
    if (postMediaType === 'MTBAG') {
      return "/images/mtbag-icon.svg";
    }
    if (postMediaType === 'MTSPM') {
      return "/images/mtspm-icon.svg";
    }
    if (postMediaType === 'MTRMP') {
      return "/images/risk-icon.svg";
    }
    return "/images/standards-plus-icon.svg";
  };

  const truncatedSource = (source) => {
    return _.truncate(source, { length: 15 });
  };

  return (
    <div
      className={
        "flex border border-gray-500 rounded-sm mb-5 overflow-auto " +
        (post.status !== "Published" ? "bg-gray-400" : "bg-white")
      }
    >
      <div className="w-full flex flex-col justify-between">
        <div>
          <div className="flex items-center px-5 py-2 justify-between w-full border-b border-gray-500">
            <div className="flex items-center">
              <span>
                <img
                  src={
                    isPmbok()
                  }
                  alt="Logo"
                  style={{ height: "38px", width: "42px" }}
                />
              </span>
              <div className="text-xs md:text-lg font-normal text-gray-900 pl-3 title-font pt-2">
                {truncatedSource(post.source)}
              </div>
            </div>
          </div>

          <div className="px-5 mt-4">
            <h1 className="text-sm sm:text-xl text-gray-900 font-normal mb-3 title-font">
              {post.title}
            </h1>
            {previewImage !== 'null' && (
              <div>
                <img
                  className="mb-2 sm:mb-5 block w-full"
                  src={previewImageFile}
                  alt="preview"
                />
              </div>
            )}

            <h3 className="text-sm sm:text-base font-normal mb-2">
              {post.description}
            </h3>
          </div>
        </div>

        <div>
          <Link
            to={`/posts/${post.contentKey}/${post.id}`}
            className="w-full block no-underline text-center font-normal text-white bg-purple-600 hover:bg-purple-800 cursor-pointer text-base sm:text-lg md:text-xl py-5 mt-3 border border-purple-600 btn-font"
          >
            CONTINUE READING
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ShortFeedItem;
